import ChangeAdminStatusDialogComponent from "./changeAdminStatusDialog.component";

export default function ChangeAdminStatusDialogContainer({
  open,
  handleClose,
  handleSubmit,
  isEnabled,
}) {
  return (
    <ChangeAdminStatusDialogComponent
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      isEnabled={isEnabled}
    />
  );
}
